import type { PlanInputFormUsageProduct, UserInputBillingInterval, BillingInterval, ProductInput, FixedProductInput } from '@weft/types';
import { COMMITMENT_TYPES, USER_INPUT_BILLING_INTERVALS } from '@weft/types';

export function adjustNewProductsIntervals(product: PlanInputFormUsageProduct | FixedProductInput, planBillingInterval: BillingInterval | undefined): ProductInput {
  const currencyCommitment = product.commitment?.type === COMMITMENT_TYPES.Price ? product.commitment.amount : undefined;
  const commitment = product.commitment?.type === COMMITMENT_TYPES.Units ? product.commitment : undefined;
  const billingInterval = fromUserInputBillingInterval(planBillingInterval, product.billingInterval);

  const isInheritingBillingIntervalFromPlan = product.billingInterval === USER_INPUT_BILLING_INTERVALS.Inherit;

  return {
    ...product,
    billingInterval,
    currencyCommitment,
    commitment,
    isPeriodicVariants: !isInheritingBillingIntervalFromPlan,
  };
}

function fromUserInputBillingInterval(
  planBillingInterval: BillingInterval | undefined,
  userInputBillingInterval: UserInputBillingInterval | undefined) {
  return userInputBillingInterval === USER_INPUT_BILLING_INTERVALS.Inherit
    ? planBillingInterval
    : userInputBillingInterval;
}